import Debbie_waiting_in_the_clock from "@bokio/assets/images/debbie/Debbie_waiting_in_the_clock.svg";
import { FancyModal } from "@bokio/components/FancyModal/FancyModal";
import { Button, ButtonGroup } from "@bokio/designsystem/components/Button";
import { LoadingContent } from "@bokio/designsystem/components/Loading";
import { Paragraph, TextSpan } from "@bokio/designsystem/components/TypographicElements/TypographicElements";
import { GeneralLangFactory } from "@bokio/lang";
import { useCompanyInfo } from "@bokio/mobile-web-shared/core/contexts/CompanyInfoContext/CompanyInfoContext";
import { usePricePlanContext } from "@bokio/mobile-web-shared/core/contexts/PricePlanContext/PricePlanContext";
import * as m from "@bokio/mobile-web-shared/core/model/model";
import { useApi } from "@bokio/mobile-web-shared/hooks/useApi/useApi";
import * as proxy from "@bokio/mobile-web-shared/services/api/proxy";
import { getRoute } from "@bokio/shared/route";
import { formatMessage } from "@bokio/shared/utils/format";
import { getPlanName } from "@bokio/utils/priceplanUtils";

import { UserTrialExtensionModal } from "./UserTrialExtensionModal";

import type { FC } from "react";

interface TrialOverModalProps {
	resolve: () => void;
}

import BokioPlan = m.Entities.BokioPlan;

export const TrialOverModal: FC<TrialOverModalProps> = ({ resolve }) => {
	const { companyInfo } = useCompanyInfo();
	const { plan } = usePricePlanContext();
	const generalLang = GeneralLangFactory();

	const [pricePlanStateRequest] = useApi(proxy.Bokio.Common.Web.Settings.SubscriptionController.PriceplanState.Get, [
		companyInfo.Id,
	]);

	if (pricePlanStateRequest.isLoading || !pricePlanStateRequest.data?.Data) {
		return <LoadingContent />;
	}

	const isEligible = pricePlanStateRequest.data.Data.IsEligibleForUserExtendedTrial;
	const extensionDays = pricePlanStateRequest.data.Data.UserExtendedTrialOfferExtensionDays;

	if (isEligible) {
		return <UserTrialExtensionModal resolve={resolve} extensionDays={extensionDays} />;
	}

	// Not eligible - show regular modal
	const headingText =
		plan === BokioPlan.Free || plan === undefined
			? generalLang.TrialOverModal_Heading
			: generalLang.TrialOverModal_Heading_OnPlan;
	const bodyText =
		plan === BokioPlan.Free || plan === undefined
			? generalLang.TrialOverModal_Text
			: formatMessage(
					generalLang.TrialOverModal_Text_OnPlan,
					<TextSpan style="body-bold">{getPlanName(plan)}</TextSpan>,
				);

	const ctaText = plan === BokioPlan.Free || plan === undefined ? generalLang.TrialOverModal_CTA : generalLang.Continue;

	return (
		<FancyModal
			testId="SMM_TO_Modal"
			visible={true}
			title={headingText}
			onClose={resolve}
			customGraphic={Debbie_waiting_in_the_clock}
			backgroundColor="white"
			width="wide"
			imageSize="large"
		>
			<Paragraph>{bodyText}</Paragraph>
			<ButtonGroup margin={["top", "bottom"]}>
				<Button
					testId="SMM_TO_button"
					type="link"
					route={getRoute("billing", { company: companyInfo.Id }, { from: "tom" })}
					onNavigation={resolve}
				>
					{ctaText}
				</Button>
			</ButtonGroup>
		</FancyModal>
	);
};
